module.exports = __webpack_public_path__ + "img/智慧荔园1.a4c036ab.png";